import styled, { css, keyframes } from 'styled-components';

export const DEF_COLOR = '#c15e4c';

const COLORS = [DEF_COLOR, 'var(--mainGreen)', ' #ec65b8', 'var(--lightGrey)'];

/** TBD Generate colors from array */
export const AlternatingColors1 = keyframes`
	0%,100% { background-color: ${COLORS[0]} }
	25% { background-color: ${COLORS[1]} }
	50% { background-color: ${COLORS[2]} }
	75% { background-color: ${COLORS[3]} }
`;

export const AlternatingColors2 = keyframes`
	0%,100% { background-color: ${COLORS[3]} }
	25% { background-color: ${COLORS[0]} }
	50% { background-color: ${COLORS[1]} }
	75% { background-color: ${COLORS[2]} }
`;

export const PatternWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const RowWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

/** If needed, another shape can be created (rectangle, traingle, diamons, star) */
export const GlowingCircle = styled.div`
  width: ${({ $diameter }) => ($diameter ? `${$diameter}px` : '5px')};
  height: ${({ $diameter }) => `${$diameter}px`};
  margin-left: ${({ $margin }) => `${$margin}px`};
  border-radius: 50%;
  background-color: ${({ $animate }) => !$animate && DEF_COLOR};

  ${({ $animationDuration }) =>
    $animationDuration &&
    css`
      animation-name: ${() => (Math.random() * 10 > 5 ? AlternatingColors1 : AlternatingColors2)};
      animation-timing-function: ease; //step-start;
      animation-duration: ${`${$animationDuration}s`};
      animation-iteration-count: infinite;
    `}
`;
